import React from 'react';

const AcessoNegado: React.FC<{ aba: string }> = ({ aba }) => {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-50 p-8">
      {/* GIF Animado - Avatar triste balançando */}
      <div className="mb-8 relative">
        <div className="w-32 h-32 mx-auto">
          {/* Simulação de GIF com CSS animations */}
          <div className="relative w-full h-full">
            {/* Avatar triste */}
            <div className="absolute inset-0 flex items-center justify-center">
              <div className="text-8xl animate-pulse">😢</div>
            </div>
            {/* Efeito de balanço */}
            <div className="absolute inset-0 flex items-center justify-center">
              <div 
                className="w-24 h-24 border-4 border-gray-300 rounded-full animate-spin"
                style={{ 
                  animationDuration: '3s',
                  animationTimingFunction: 'ease-in-out',
                  animationIterationCount: 'infinite'
                }}
              />
            </div>
          </div>
        </div>
      </div>

      {/* Mensagem principal */}
      <h1 className="text-3xl font-bold text-gray-800 mb-4 text-center">
        Ops! Acesso Negado
      </h1>

      {/* Mensagem explicativa */}
      <p className="text-lg text-gray-600 mb-2 text-center">
        Desculpe, você não tem permissão para acessar a aba
      </p>
      
      <p className="text-2xl font-semibold text-blue-600 mb-8 text-center">
        "{aba}"
      </p>

      {/* Mensagem adicional */}
      <div className="bg-white rounded-lg shadow-md p-6 max-w-md">
        <p className="text-gray-700 text-center mb-4">
          Entre em contato com o administrador do sistema para solicitar acesso a esta funcionalidade.
        </p>
        
        {/* GIF de não balançando */}
        <div className="flex justify-center mb-4">
          <div 
            className="text-6xl"
            style={{
              animation: 'shake 0.5s ease-in-out infinite',
              transformOrigin: 'center bottom'
            }}
          >
            ☝️
          </div>
        </div>

        <p className="text-sm text-gray-500 text-center italic">
          "Acesso não permitido"
        </p>
      </div>

      {/* Botão para voltar */}
      <button
        onClick={() => window.history.back()}
        className="mt-8 px-6 py-3 bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition-colors"
      >
        Voltar
      </button>

      {/* CSS Animations */}
      <style>{`
        @keyframes shake {
          0%, 100% { transform: translateX(0); }
          25% { transform: translateX(-10px) rotate(-5deg); }
          75% { transform: translateX(10px) rotate(5deg); }
        }
      `}</style>
    </div>
  );
};

export default AcessoNegado;
